<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.17 1.17C3.92 0.42 4.94 0 6 0C7.06 0 8.08 0.42 8.83 1.17C9.58 1.92 10 2.94 10 4C10 6.07 6.4 11.41 6.03 11.95C6.01 11.98 6 11.99 6 12C5.96 11.94 2 6.18 2 4C2 2.94 2.42 1.92 3.17 1.17ZM4.15 3.23C4 3.6 3.96 4 4.04 4.39C4.12 4.78 4.31 5.13 4.59 5.41C4.87 5.69 5.23 5.88 5.61 5.96C6 6.04 6.4 6 6.77 5.85C7.14 5.7 7.45 5.44 7.67 5.11C7.89 4.78 8.01 4.39 8.01 4C8.01 3.47 7.8 2.96 7.42 2.59C7.04 2.21 6.54 2 6.01 2C5.61 2 5.23 2.12 4.9 2.34C4.57 2.56 4.32 2.87 4.16 3.24L4.15 3.23Z"
        />
    </svg>
</template>
